export enum OrderBy {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface IFilters {
  page: number
  per_page: number
  order_by?: string
  order_by_order?: OrderBy
}

export interface IFragmentFilters extends IFilters {
  fragment?: string
}
